<footer class="bg-primary-500">
  <div class="mx-auto flex max-w-screen-xxl flex-col gap-4 p-4 text-white lg:px-5 xl:px-15 xxl:px-20">
    <div class="flex flex-col lg:flex-row justify-center xl:justify-between">
      <section class="pb-4 lg:pb-0 flex justify-content-center gap-12 lg:order-2 lg:gap-4">
        <a
          *ngIf="aplikacjeMobilne?.czyUdostepniacAplikacjeAndroid"
          [href]="aplikacjeMobilne?.adresUrlAplikacjiAndroid"
          target="_blank"
        >
          <img
            src="assets/img/google-play-badge.png"
            class="-my-1.5 h-[3.25rem]"
            alt="Pobierz z Google Play"
            i18n-alt
            loading="lazy"
          />
        </a>
        <a
          *ngIf="aplikacjeMobilne?.czyUdostepniacAplikacjeIos"
          [href]="aplikacjeMobilne?.adresUrlAplikacjiIos"
          target="_blank"
        >
          <img src="assets/svg/badge_app_store.svg" class="h-10" alt="Pobierz w App Store" i18n-alt loading="lazy" />
        </a>
      </section>

      <span class="flex justify-between lg:justify-normal gap-16">
        <img src="assets/img/logo_fundusze_europejskie.svg" alt="Logotyp Funduszy Europejskich" i18n-alt />
        <img src="assets/img/logo_ue.svg" alt="Logotyp Unii Europejskiej" i18n-alt />
      </span>
    </div>

    <div class="border-t border-t-white pt-4 text-center text-xs">
      <div i18n>© 2020-2024 American Systems. Wszelkie prawa zastrzeżone.</div>
    </div>
  </div>
</footer>
